import React, { useEffect } from 'react';
import CenterStage from '../Components/CenterStage/CenterStage';
import imgCareerStage from '../assets/stage-1.jpg';
import Promoter from '../Components/Promoter/Promoter';
import { Col, Row } from 'react-bootstrap';
import { MdEmail, MdLocationOn } from 'react-icons/md';
import imgWork from '../assets/Careers/work.png';
import TwoColumnPoints from '../Components/TwoColumnPoints/TwoColumnPoints';
import SectionHeader from '../Components/SectionHeader/SectionHeader';
import TextCaption from '../Components/TextCaption/TextCaption';

function Careers() {

    const isMobile = window.innerWidth <= 768;
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);
    const listItems = ["Health insurance", "Dental insurance", "Welhub (well-being and quality of life programme)", "Food vouchers and/or meal vouchers", "Transport vouchers", "Life insurance"]

    return (
        <div>
            <CenterStage title={"Working at Hansa-Flex"} imageSrc={imgCareerStage} paragraph={"At HANSA-FLEX, we believe that when people feel cared for, recognised and connected to their purpose, they deliver their best. That is why we have created a welcoming, safe and inspiring work environment — where every employee has space to develop, contribute and grow."} />

            <SectionHeader title="Open feedback culture and collective actions" />
            <TextCaption
                bulletPoints={[
                    "Our culture is based on trust, with sincere conversations and open dialogue that strengthen the sense of belonging. We are a family-owned company with lean hierarchies, which facilitates exchange between sectors, brings leaders closer together, and encourages new forms of collaboration.",
                    "We value unity and believe that celebrating achievements is also part of building a great team. That is why we promote internal events, joint activities and initiatives that bring people together, reinforce our values and strengthen our relationships.",
                ]} />

            <div>
                <TwoColumnPoints points={listItems} title={"Our benefits"} subtitle={"Caring is an essential part of our culture. That is why we offer a benefits package that supports the health and well-being of our employees."} />
            </div>

            <div>
                <SectionHeader
                    title="Growth and Development"
                    subtitle={"We believe that growth is part of the journey. That is why we encourage and support the continuous development of each employee, offering real opportunities for advancement within HANSA-FLEX:"} />
                <TextCaption
                    bulletPoints={[
                        "Technical and behavioural training, which strengthens essential skills for everyday life and for building solid careers.",
                        "Internal training and integration programmes that facilitate adaptation, strengthen skills and bring our teams closer together.",
                        "Opportunities for growth in a multinational company connected to different cultures, markets and technologies.",
                        "Encouragement of continuous learning and knowledge exchange, stimulating collaboration, innovation and joint development between teams and units.",
                    ]} />
            </div>

            <div className='div-gray'>
                <SectionHeader subtitle={'“Here at HANSA-FLEX, you will find more than just a job — you will find a team that believes in your potential, supports your growth and walks alongside you to build achievements together.”'}
                    paragraph={"Send your CV to: rh@hansa-flex.com"} />
                <br /><br />
            </div>
            <br /><br />

        </div>
    );
}

export default Careers;